import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unlinkButtonLabelNonFinal: {
		id: 'polaris-ideas.idea-view.connections.content.cells.summary.unlink.unlink-button-label-non-final',
		defaultMessage: 'Unlink',
		description: 'Button label to unlink an issue',
	},
});
